import { render, staticRenderFns } from "./LivenessCheckList.vue?vue&type=template&id=575da4de&"
import script from "./LivenessCheckList.vue?vue&type=script&lang=js&"
export * from "./LivenessCheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports